import { render, staticRenderFns } from "./AddIntegration.vue?vue&type=template&id=2855eb1a"
import script from "./AddIntegration.vue?vue&type=script&lang=js"
export * from "./AddIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports